import { defineComponent as _defineComponent } from 'vue'

  import { EstateMapInterface } from "@/types/EstateMapInterface";
  import { getStageStatusClass } from "@/helpers/status";
  import { StageStatus } from "@/enums/StageStatus";
  import { UserRoles } from "@/enums/UserRoles";
  import { LotMapInterface } from "@/types/LotMapInterface";
  import { LotStatus } from "@/enums/LotStatus";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'StageSvgMap',
  props: {
    map: {},
    lots: {},
    zoom: {},
    getTooltipText: { type: Function },
    getItemWrClasses: { type: Function },
    getItemPathClasses: { type: Function },
    getItemStatusPathClasses: { type: Function }
  },
  emits: ["onLotHover", "onLotLeave", "onLotClick"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emits = __emit;

  const onLotHover = (id: string) => {
    emits("onLotHover", id);
  };

  const onLotLeave = () => {
    emits("onLotLeave");
  };

  const onLotClick = (stage: LotMapInterface) => {
    emits("onLotClick", stage);
  };

const __returned__ = { props, emits, onLotHover, onLotLeave, onLotClick, get EstateMapInterface() { return EstateMapInterface }, get getStageStatusClass() { return getStageStatusClass }, get StageStatus() { return StageStatus }, get UserRoles() { return UserRoles }, get LotMapInterface() { return LotMapInterface }, get LotStatus() { return LotStatus } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})